import { Box } from "@mui/material";
import { useEffect, useState } from "react";
import { methodGetNoticeBoard, methodSetNoticeBoard } from "../../../../../api/apiproject/api";
import { DivRichText } from "../../../../../component/basic/data_displays/rich_text/DivRichText";
import { SearchHighlight } from "../../../../../component/basic/data_displays/rich_text/Highlight";
import { AlertSuccess } from "../../../../../component/basic/feedbacks/snackbar/Snackbar";
import { RichText } from "../../../../../model/question/RichText";
import { useAppDispatch } from "../../../../../store/hooks";
import "./NoticeContent.css";

export function NoticeContent() {
    const dispatch = useAppDispatch();
    const [data, setData] = useState({ text: new RichText(), isBackend: false });

    useEffect(() => {
        if (data.isBackend) {
            return;
        }
        methodGetNoticeBoard(dispatch, {}).then((rsp) =>
            setData({ text: rsp.text, isBackend: true })
        );
    }, [data, dispatch]);

    return (
        <Box
            sx={{
                flexGrow: "1",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                marginTop: "40px",
                fontSize: 20,
                paddingRight: "20px",
                paddingLeft: "20px",
            }}
        >
            <Box>
                <SearchHighlight>
                    <DivRichText
                        content={data.text}
                        onSave={(t: RichText) => {
                            methodSetNoticeBoard(dispatch, { text: t }).then(() => {
                                setData({ text: t, isBackend: true });
                                AlertSuccess("修改成功");
                            });
                        }}
                    />
                </SearchHighlight>
            </Box>
        </Box>
    );
}
